// Cent rounding, aligned with the reference engine in `assets/donnees-demo.js`.
// HZ-SFD-002 mentions "arrondi bancaire": in v1 this is realized as round-half-away
// from zero at the cent, identical to the prototype so the front, the engine and the
// server produce the exact same series (T08 DoD, replayability CA-12).

/** Round a euro amount to the nearest cent. */
export function arrondiCentime(x: number): number {
  // Number.EPSILON nudge avoids binary artefacts such as 1.005 -> 1.00.
  const signe = x < 0 ? -1 : 1;
  return (signe * Math.round(Math.abs(x) * 100 + Number.EPSILON)) / 100;
}
